<nav class="list-group list-group-flush bg-secondary min-h-vh ">

  <ng-container *appIfHasAnyPermissions="[
  permission.GUEST_READ_ALL,
  permission.BOOKINGS_SLOT_READ_ALL,
  permission.VEHICLECONSULTATIONS_BOOKINGS_BOOKING_READ_ALL,
  permission.ORDERS_COLLECTORS_COLLECTORCASE_READ_ALL
  ]">
    <li
      class="list-group-item list-group-item-sidebar"
      (click)="toggle(content.GUEST_MANAGEMENT)"
    >
      <i class="icon-guest-management"></i>
      {{ 'sidebar.guest_management.guest_management' | translate }}
      <i class="fa-solid position-absolute end-0 me-3 mt-1"
         [class.fa-chevron-up]="!collapsed(content.GUEST_MANAGEMENT)"
         [class.fa-chevron-down]="collapsed(content.GUEST_MANAGEMENT)"></i>
    </li>
    <ng-container *ngIf="!collapsed(content.GUEST_MANAGEMENT)">


      <!-- vehicle pickup users should not directly see all guests endpoint as it is useless for them  -->
      <a
        *appIfHasAllAndAnyPermissions="{all: [permission.GUEST_READ_ALL], any: [permission.ORDERS_ORDER_READ_ALL, permission.VEHICLECONSULTATIONS_BOOKINGS_BOOKING_READ_ALL]}"
        [routerLinkActive]="['active']"
        [routerLink]="'/guest-management/guests'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-guests"></i>
        {{ 'sidebar.guest_management.guests' | translate }}
      </a>

      <a
        *appIfHasAnyPermissions="[permission.ORDERS_ORDER_READ_ALL, permission.VEHICLECONSULTATIONS_BOOKINGS_BOOKING_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/guest-management/orders'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-bookings"></i>
        {{ 'sidebar.guest_management.orders' | translate }}
      </a>

      <a
        *appIfHasAllPermissions="[permission.ORDERS_COLLECTORS_COLLECTORCASE_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/guest-management/collectors'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-deliveries"></i>
        {{ 'sidebar.guest_management.collectors' | translate }}
      </a>
    </ng-container>
  </ng-container>

  <ng-container *appIfHasAnyPermissions="[
  permission.EVENTMANAGEMENT_CUSTOMERS_CUSTOMERCONTACT_READ_ALL,
  permission.EVENTMANAGEMENT_CUSTOMERS_CUSTOMER_READ_ALL,
  permission.EVENTMANAGEMENT_EVENTS_EVENT_READ_ALL,
  permission.EVENTMANAGEMENT_BLOCKEDRESOURCE_BLOCKEDRESOURCEDEFINITION_READ_ALL,
  permission.EVENTMANAGEMENT_OCCURRENCE_OCCURRENCE_READ_ALL,
  permission.EVENTMANAGEMENT_CALENDAR_EVENTMANAGEMENTCALENDARMONTHVIEW_READ_ALL,
  permission.EVENTMANAGEMENT_CALENDAR_EVENTMANAGEMENTCALENDARVIEW_READ_ALL,
  permission.REPORTING_TEMPLATE_READ_ALL
  ]">
    <li
      class="list-group-item list-group-item-sidebar"
      (click)="toggle(content.EVENT_MANAGEMENT)"
    >
      <i class="icon-planning-list"></i>

      {{ 'sidebar.event_management.event_management' | translate }}
      <i class="fa-solid position-absolute end-0 me-3 mt-1"
         [class.fa-chevron-up]="!collapsed(content.EVENT_MANAGEMENT)"
         [class.fa-chevron-down]="collapsed(content.EVENT_MANAGEMENT)"></i>
    </li>

    <ng-container *ngIf="!collapsed(content.EVENT_MANAGEMENT)">
      <a
        *appIfHasAllPermissions="[permission.EVENTMANAGEMENT_EVENTS_EVENT_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/event-management/dashboard'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-dashboard"></i>
        {{ 'sidebar.event_management.dashboard' | translate }}
      </a>

      <a
        *appIfHasAnyPermissions="[permission.EVENTMANAGEMENT_CALENDAR_EVENTMANAGEMENTCALENDARMONTHVIEW_READ_ALL, permission.EVENTMANAGEMENT_CALENDAR_EVENTMANAGEMENTCALENDARVIEW_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/event-management/calendar'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-planning-calender"></i>
        {{ 'sidebar.event_management.calendar' | translate }}
      </a>

      <a
        *appIfHasAllPermissions="[permission.EVENTMANAGEMENT_EVENTS_EVENT_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/event-management/events'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-event"></i>
        {{ 'sidebar.event_management.events' | translate }}
      </a>

      <a
        *appIfHasAllPermissions="[permission.EVENTMANAGEMENT_BLOCKEDRESOURCE_BLOCKEDRESOURCEDEFINITION_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/event-management/blocked-resources'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-blocker"></i>
        {{ 'sidebar.event_management.blocker' | translate }}
      </a>

      <!-- check permission.EVENTMANAGEMENT_EVENTS_EVENT_READ_ALL as well to hide it for calendar users -->
      <a
        *appIfHasAllPermissions="[permission.EVENTMANAGEMENT_OCCURRENCE_OCCURRENCE_READ_ALL, permission.EVENTMANAGEMENT_EVENTS_EVENT_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/event-management/occurrences'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-notifications"></i>
        {{ 'sidebar.event_management.external_events' | translate }}
      </a>

      <a
        *appIfHasAllPermissions="[permission.EVENTMANAGEMENT_CUSTOMERS_CUSTOMER_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/event-management/customers'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-customers"></i>
        {{ 'sidebar.event_management.customers' | translate }}
      </a>

      <a
        *appIfHasAllPermissions="[permission.EVENTMANAGEMENT_CUSTOMERS_CUSTOMERCONTACT_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/event-management/contacts'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-contacts"></i>
        {{ 'sidebar.event_management.contacts' | translate }}
      </a>

      <a
        *appIfHasAllPermissions="[permission.REPORTING_TEMPLATE_READ_ALL, permission.EVENTMANAGEMENT_EVENTS_EVENT_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/event-management/reports'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-reports"></i>
        {{ 'sidebar.event_management.reports' | translate }}
      </a>
    </ng-container>
  </ng-container>

  <ng-container *appIfHasAnyPermissions="[
  permission.ACCOUNTING_DOCUMENT_READ_ALL,
  ]">
    <li
      class="list-group-item list-group-item-sidebar"
      (click)="toggle(content.ACCOUNTING)">
      <i class="icon-accounting"></i>
      {{ 'sidebar.accounting.accounting' | translate }}
      <i class="fa-solid position-absolute end-0 me-3 mt-1"
         [class.fa-chevron-up]="!collapsed(content.ACCOUNTING)"
         [class.fa-chevron-down]="collapsed(content.ACCOUNTING)"
      ></i>
    </li>
    <ng-container *ngIf="!collapsed(content.ACCOUNTING)">
      <a
        *appIfHasAllPermissions="[permission.ACCOUNTING_DOCUMENT_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/accounting/invoices'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-invoices"></i>
        {{ 'sidebar.accounting.invoices' | translate }}
      </a>

      <a
        *appIfHasAllPermissions="[permission.ACCOUNTING_DOCUMENT_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/accounting/credits'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-credits"></i>
        {{ 'sidebar.accounting.credits' | translate }}
      </a>

      <a
        *appIfHasAllPermissions="[permission.ACCOUNTING_DAYENDCLOSING_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/accounting/day-end-closings'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-invoices"></i>
        {{ 'sidebar.accounting.day_end_closings' | translate }}
      </a>
    </ng-container>
  </ng-container>


  <ng-container *appIfHasAnyPermissions="[
  permission.BOOKINGS_SLOT_READ_ALL,
  permission.BOOKINGS_SLOT_READ_ALL,
  permission.BOOKINGS_SLOT_READ_ALL,
  ]">
    <li
      class="list-group-item list-group-item-sidebar"
      (click)="toggle(content.PLANNING)"
    >
      <i class="icon-planning"></i>
      {{ 'sidebar.orders.planning' | translate }}
      <i class="fa-solid position-absolute end-0 me-3 mt-1"
         [class.fa-chevron-up]="!collapsed(content.PLANNING)"
         [class.fa-chevron-down]="collapsed(content.PLANNING)"
      ></i>
    </li>
    <ng-container *ngIf="!collapsed(content.PLANNING)">
      <a
        *appIfHasAllPermissions="[permission.BOOKINGS_SLOT_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/orders/slots/calendar'"
        [routerLinkActiveOptions]="{paths: 'exact', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'exact'}"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-planning-calender"></i>
        {{ 'sidebar.orders.calendar' | translate }}
      </a>

      <a
        *appIfHasAllPermissions="[permission.BOOKINGS_SLOT_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{paths: 'exact', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'exact'}"
        [routerLink]="'/orders/slots'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-planning-list"></i>
        {{ 'sidebar.orders.list' | translate }}
      </a>

      <a
        *appIfHasAllPermissions="[permission.BOOKINGS_SLOT_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/orders/museum'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-opening-hours-museum"></i>
        {{ 'sidebar.orders.opening_hours_museum' | translate }}
      </a>
    </ng-container>
  </ng-container>

  <!-- DON'T add the Guide Read all permission to the permission list until first production release -->
  <ng-container *appIfHasAnyPermissions="[
  permission.VEHICLECONSULTATIONS_COUNSELLINGDESKS_COUNSELLINGDESK_READ_ALL,
  permission.VEHICLECONSULTATIONS_VEHICLES_VEHICLE_READ_ALL,
  permission.VEHICLECONSULTATIONS_AVAILABILITY_READ_ALL,
  permission.VEHICLECONSULTATIONS_AVAILABILITYSETTING_READ_ALL,
  permission.VEHICLECONSULTATIONS_COUNSELLINGDESKS_COUNSELLINGDESKAVAILABILITY_READ_ALL,
  permission.VEHICLECONSULTATIONS_VEHICLES_VEHICLEAVAILABILITY_READ_ALL,
 ]">

    <li
      class="list-group-item list-group-item-sidebar"
      (click)="toggle(content.VEHICLE_CONSULTATION)"
    >
      <i class="icon-settings"></i>
      {{ 'sidebar.vehicle_consultations.vehicle_consultations' | translate }}
      <i class="fa-solid position-absolute end-0 me-3 mt-1"
         [class.fa-chevron-up]="!collapsed(content.VEHICLE_CONSULTATION)"
         [class.fa-chevron-down]="collapsed(content.VEHICLE_CONSULTATION)"
      ></i>
    </li>
    <ng-container *ngIf="!collapsed(content.VEHICLE_CONSULTATION)">
      <a
        *appIfHasAnyPermissions="[permission.ORDERS_ORDER_READ_ALL, permission.VEHICLECONSULTATIONS_BOOKINGS_BOOKING_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/guest-management/vehicle-consultations/orders'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="fa fa-car ms-1 me-2"></i>
        {{ 'sidebar.guest_management.vc_orders' | translate }}
      </a>

      <a
        *appIfHasAllPermissions="[permission.VEHICLECONSULTATIONS_AVAILABILITY_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/vehicle-consultations/calendar'"
        class="list-group-item list-group-item-sidebar-secondary ">
        <i class="icon-planning-calender"></i>
        {{ 'sidebar.vehicle_consultations.vehicle_consultations_calendar' | translate }}
      </a>


      <a
        *appIfHasAllPermissions="[permission.VEHICLECONSULTATIONS_GENIUS_GENIUSAVAILABILITY_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/vehicle-consultations/genius-availability'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="fa fa-people-group ms-1 me-2"></i>
        {{ 'sidebar.vehicle_consultations.guide_availability' | translate }}
      </a>

      <a
        *appIfHasAllPermissions="[permission.VEHICLECONSULTATIONS_VEHICLES_VEHICLEAVAILABILITY_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/vehicle-consultations/availability'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-planning-calender"></i>
        {{ 'sidebar.vehicle_consultations.availability' | translate }}
      </a>


      <a
        *appIfHasAllPermissions="[permission.RESOURCES_GUIDE_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/resources/guides'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-guides"></i>
        {{ 'sidebar.resources.guides' | translate }}
      </a>


      <a
        *appIfHasAllPermissions="[permission.VEHICLECONSULTATIONS_VEHICLES_VEHICLE_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/vehicle-consultations/vehicles'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="fa fa-car ms-1 me-2"></i>
        {{ 'sidebar.vehicle_consultations.vehicles' | translate }}
      </a>


      <a
        *appIfHasAllPermissions="[permission.VEHICLECONSULTATIONS_COUNSELLINGDESKS_COUNSELLINGDESK_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/vehicle-consultations/counselling-desks'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="fa fa-desktop ms-1 me-2"></i>
        {{ 'sidebar.vehicle_consultations.counselling_desks' | translate }}
      </a>

    </ng-container>
  </ng-container>

  <ng-container *appIfHasAnyPermissions="[
  permission.RESOURCES_GUIDE_READ_ALL,
  ]">
    <li
      class="list-group-item list-group-item-sidebar"
      (click)="toggle(content.RESOURCES)">
      <i class="icon-resources"></i>
      {{ 'sidebar.resources.resources' | translate }}
      <i class="fa-solid position-absolute end-0 me-3 mt-1"
         [class.fa-chevron-up]="!collapsed(content.RESOURCES)"
         [class.fa-chevron-down]="collapsed(content.RESOURCES)"
      ></i>
    </li>
    <ng-container *ngIf="!collapsed(content.RESOURCES)">
      <a
        *appIfHasAllPermissions="[permission.RESOURCES_ROOM_ROOM_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/resources/rooms'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-event-rooms"></i>
        {{ 'sidebar.resources.rooms' | translate }}
      </a>

      <a
        *appIfHasAllPermissions="[permission.RESOURCES_EQUIPMENT_EQUIPMENT_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/resources/equipment'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-equipment"></i>
        {{ 'sidebar.resources.equipment' | translate }}
      </a>

      <a
        *appIfHasAllPermissions="[permission.RESOURCES_SERVICE_SERVICE_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/resources/services'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-services"></i>
        {{ 'sidebar.resources.services' | translate }}
      </a>

      <a
        *appIfHasAllPermissions="[permission.RESOURCES_PACKAGE_PACKAGE_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/resources/packages'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-packages"></i>
        {{ 'sidebar.resources.packages' | translate }}
      </a>

      <a
        *appIfHasAllPermissions="[permission.RESOURCES_GUIDE_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/resources/guides'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-guides"></i>
        {{ 'sidebar.resources.guides' | translate }}
      </a>

      <a
        *appIfHasAllPermissions="[permission.RESOURCES_SERVICEPROVIDER_SERVICEPROVIDER_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/resources/service-providers'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-service-providers"></i>
        {{ 'sidebar.resources.service-providers' | translate }}
      </a>

      <a
        *appIfHasAllPermissions="[permission.RESOURCES_SERVICEPROVIDER_SERVICEPROVIDERINQUIRY_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/resources/service-provider-inquiries'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-service-provider-requests"></i>
        {{ 'sidebar.resources.service-provider-inquiries' | translate }}
      </a>

      <a
        *appIfHasAllPermissions="[permission.RESOURCES_SERVICEPROVIDER_SERVICEPROVIDERBUDGET_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/resources/service-provider-budgets'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-service-provider-budget"></i>
        {{ 'sidebar.resources.service-provider-budgets' | translate }}
      </a>

      <a
        *appIfHasAllPermissions="[]"
        [routerLinkActive]="['active']"
        [routerLink]="'/seating-plans'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class=""></i>
        {{ 'sidebar.resources.seating_plans' | translate }}
      </a>
    </ng-container>
  </ng-container>


  <ng-container *appIfHasAnyPermissions="[
  permission.SETTINGS_ARTICLE_READ_ALL,
  permission.SETTINGS_BOOKINGQUESTION_READ_ALL,
  permission.SETTINGS_DISCOUNTREASON_READ_ALL,
  permission.SETTINGS_CANCELLATIONREASON_READ_ALL,
  permission.SETTINGS_LOCATION_READ_ALL,
  permission.SETTINGS_VENUE_READ_ALL,
  permission.SETTINGS_SEGMENT_READ_ALL,
  permission.SETTINGS_TARGETAUDIENCE_READ_ALL,
  permission.SETTINGS_SETTLEMENTACCOUNT_READ_ALL,
  permission.SETTINGS_LANGUAGESKILL_READ_ALL,


  ]">

    <li
      class="list-group-item list-group-item-sidebar"
      (click)="toggle(content.SETTINGS)"
    >
      <i class="icon-settings"></i>
      {{ 'sidebar.settings.settings' | translate }}
      <i class="fa-solid position-absolute end-0 me-3 mt-1"
         [class.fa-chevron-up]="!collapsed(content.SETTINGS)"
         [class.fa-chevron-down]="collapsed(content.SETTINGS)"
      ></i>
    </li>
    <ng-container *ngIf="!collapsed(content.SETTINGS)">
      <a
        *appIfHasAllPermissions="[permission.SETTINGS_ARTICLE_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/settings/articles'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-articles"></i>
        {{ 'sidebar.settings.articles' | translate }}
      </a>

      <a
        *appIfHasAllPermissions="[permission.SETTINGS_BOOKINGQUESTION_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/settings/booking-questions'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-booking-questions"></i>
        {{ 'sidebar.settings.booking_questions' | translate }}
      </a>
      <a
        *appIfHasAllPermissions="[permission.SETTINGS_DISCOUNTREASON_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/settings/discount-reasons'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-discount-reasons"></i>
        {{ 'sidebar.settings.discount_reasons' | translate }}
      </a>
      <a
        *appIfHasAllPermissions="[permission.SETTINGS_CANCELLATIONREASON_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/settings/cancellation-reasons'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-cancellation-reasons"></i>
        {{ 'sidebar.settings.cancellation_reasons' | translate }}
      </a>
      <a
        *appIfHasAllPermissions="[permission.SETTINGS_LOCATION_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/settings/locations'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-locations"></i>
        {{ 'sidebar.settings.locations' | translate }}
      </a>
      <a
        *appIfHasAllPermissions="[permission.SETTINGS_VENUE_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/settings/venues'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-venues"></i>
        {{ 'sidebar.settings.venues' | translate }}
      </a>
      <a
        *appIfHasAllPermissions="[permission.SETTINGS_SEGMENT_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/settings/segments'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-segments"></i>
        {{ 'sidebar.settings.segments' | translate }}
      </a>
      <a
        *appIfHasAllPermissions="[permission.SETTINGS_TARGETAUDIENCE_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/settings/target-groups'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-target-groups"></i>
        {{ 'sidebar.settings.target_groups' | translate }}
      </a>
      <a
        *appIfHasAllPermissions="[permission.SETTINGS_SETTLEMENTACCOUNT_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/settings/settlement-accounts'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-settlement-accounts"></i>
        {{ 'sidebar.settings.settlement_accounts' | translate }}
      </a>

      <a
        *appIfHasAllPermissions="[permission.SETTINGS_LANGUAGESKILL_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/settings/language-skills'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-language-skills"></i>
        {{ 'sidebar.settings.language_skills' | translate }}
      </a>

      <a
        *appIfHasAllPermissions="[permission.SETTINGS_VOUCHERS_VOUCHERCONFIGTEMPLATE_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/settings/voucher-config-templates'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-tickets">
          <i class="path1"></i>
        </i>
        {{ 'sidebar.settings.voucher_config_templates' | translate }}
      </a>


    </ng-container>
  </ng-container>


  <ng-container *appIfHasAnyPermissions="[
  permission.USER_READ_ALL,
  permission.ADMINISTRATIONS_PAGE_READ_ALL,
  permission.ADMINISTRATIONS_EMAIL_READ_ALL,
  permission.ADMINISTRATIONS_CONTENTELEMENT_READ_ALL,
  ]">

    <a
      class="list-group-item list-group-item-sidebar"
      (click)="toggle(content.ADMINISTRATIONS)"
      [attr.aria-expanded]="!collapsed(content.ADMINISTRATIONS)">
      <i class="icon-administration"></i>
      {{ 'sidebar.administration.administration' | translate }}
      <i class="fa-solid position-absolute end-0 me-3 mt-1"
         [class.fa-chevron-up]="!collapsed(content.ADMINISTRATIONS)"
         [class.fa-chevron-down]="collapsed(content.ADMINISTRATIONS)"></i>
    </a>
    <ng-container *ngIf="!collapsed(content.ADMINISTRATIONS)">

      <!-- <a

         [routerLinkActive]="['active']"
         *appIfHasAllPermissions="[permission.USER_READ_ALL]"
         [routerLink]="'/administration/users'"
         class="list-group-item list-group-item-sidebar-secondary">
         <i class="icon-user"></i>
         {{ 'sidebar.administration.user' | translate }}
       </a>-->

      <a
        *appIfHasAllPermissions="[permission.ADMINISTRATIONS_PAGE_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/administration/pages'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-pages"></i>
        {{ 'sidebar.administration.pages' | translate }}
      </a>
      <a
        *appIfHasAllPermissions="[permission.ADMINISTRATIONS_CONTENTELEMENT_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/administration/content-elements'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-pages"></i>
        {{ 'sidebar.administration.content-elements' | translate }}
      </a>


      <a
        *appIfHasAllPermissions="[permission.ADMINISTRATIONS_EMAIL_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/administration/emails'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-emails"></i>
        {{ 'sidebar.administration.emails' | translate }}
      </a>

      <a
        *appIfHasAllPermissions="[permission.ADMINISTRATIONS_TEXTBLOCK_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/administration/textblocks'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-text-blocks"></i>
        {{ 'sidebar.administration.textblocks' | translate }}
      </a>

      <a
        *appIfHasAllPermissions="[]"
        [routerLinkActive]="['active']"
        [routerLink]="'/administration/tickets'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-tickets"></i>
        {{ 'sidebar.administration.tickets' | translate }}
      </a>
      <a
        *appIfHasAllAndAnyPermissions="{all: [permission.REPORTING_TEMPLATE_READ_ALL], any: [permission.ORDERS_COLLECTORS_COLLECTORCASE_READ_ALL, permission.ORDERS_ORDER_READ_ALL]}"
        [routerLinkActive]="['active']"
        [routerLink]="'/administration/reports'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-reports"></i>
        {{ 'sidebar.administration.reports' | translate }}
      </a>
      <a
        *appIfHasAllPermissions="[permission.REPORTING_TEMPLATE_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/administration/dashboards'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="icon-reports"></i>
        {{ 'sidebar.administration.dashboards' | translate }}
      </a>
      <a
        *appIfHasAllPermissions="[permission.ATTACHMENT_READ_ALL]"
        [routerLinkActive]="['active']"
        [routerLink]="'/administration/attachments'"
        class="list-group-item list-group-item-sidebar-secondary">
        <i class="fa fa-cloud-upload ms-1 me-2"></i>
        {{ 'sidebar.administration.attachments' | translate }}
      </a>


    </ng-container>
  </ng-container>

  <a
    (click)="logout()"
    class="list-group-item list-group-item-sidebar">
    <i class="fa fa-external-link"></i> Logout
  </a>


  <a
    *appIfHasAllPermissions="[permission.DEVELOPMENT_READ_ALL]"
    [routerLinkActive]="['active']"
    [routerLink]="'/bootstrap'"
    class="list-group-item list-group-item-sidebar">
    <i class="fa fa-book"></i> DEV Bootstrap
  </a>


</nav>
